(function () {
    'use strict';
    var controllerId = 'avvisoCurriculum';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', '$uibModalInstance', avvisoCurriculumFn]);

    function avvisoCurriculumFn($scope, $rootScope, $uibModalInstance) {      
        $scope.personale = $rootScope.isAuthorized('PERSONALE');

        $scope.ok = function () {
            $uibModalInstance.close();
        };
    }
})();